import type { ReactNode } from "react";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@bindery/ui/components/ui/button";

/**
 * The one action these pages offer: leave, for somewhere else.
 *
 * A wrapper around packages/ui's Button rather than an edit to it — per
 * AGENTS.md the generated shadcn files stay diffable against a fresh
 * `shadcn add`, so the three things this surface wants differently (full
 * width, taller, and the affordance pushed to the trailing edge instead of
 * centred) are applied from out here.
 *
 * `justify-between` with the arrow at the far edge is the deliberate part: a
 * centred label with an icon beside it reads as a call to action, and nothing
 * on a payment interstitial is being sold. Pushed apart, it reads as a row in
 * the document — a destination and a way out to it.
 *
 * Always an `<a>`, never react-router's `Link`: every destination here is a
 * different origin (the consumer app that sent the shopper, or sara.ai), so a
 * client-side navigation would be wrong in every case.
 */
export function ActionLink({
  href,
  variant = "default",
  children,
}: {
  readonly href: string;
  readonly variant?: "default" | "outline";
  readonly children: ReactNode;
}) {
  return (
    <Button
      asChild
      variant={variant}
      className="h-11 w-full justify-between px-4"
    >
      <a href={href}>
        <span className="truncate">{children}</span>
        <ArrowUpRight className="size-4 shrink-0 opacity-70" aria-hidden />
      </a>
    </Button>
  );
}
